const baseURL = process.env.NODE_ENV === 'production'
  ? `${window.location.protocol}//${window.location.hostname}/api/`
  : 'http://localhost:5000/api/'

async function request (route, params, method = 'GET', responseType = 'json') {
  const options = {
    method,
    headers: {
      contentType: `application/${responseType}; charset=utf8`,
      Accept: `application/${responseType}`
    }
  }

  if (params) {
    if (method === 'GET') {
      route += `/${objectToQueryString(params)}`
    } else {
      options.body = params
    }
  }
  if (responseType === 'blob') delete options.headers.ContentType

  let response = null

  response = await fetch(`${baseURL}${route}`, options)

  if (response.status !== 200) {
    if (responseType === 'blob') {
      const result = await response[responseType]()
      return result
    } else {
      return generateErrorResponse(
        `Ocorreu um erro ao realizar a requisição. - ${response.statusText}`,
        response.status
      )
    }
  }

  const result = await response[responseType]()

  return result
}

function objectToQueryString (obj) {
  if (typeof obj !== 'object') {
    return `${obj}`
  }
  return obj.join('/').slice(0, -1)
}

function generateErrorResponse (message, code) {
  return {
    status: 'error',
    message,
    code
  }
}

function get (route, params, responseType) {
  return request(route, params, 'GET', responseType)
}

function post (route, params) {
  return request(route, params, 'POST')
}

function update (route, params) {
  return request(route, params, 'PUT')
}

function remove (route, params) {
  return request(route, params, 'DELETE')
}

export default {
  get,
  post,
  update,
  remove
}
